/**
 * Premium Planning Shell Component
 * 
 * Wraps premium planning pages (Menu Scheduling, Grocery List, Menu Planning)
 * with consistent themed backgrounds (tomato/lemon/spinach) and beige base.
 * 
 * Applies:
 * - Beige base background (#EEEEE7)
 * - Subtle tiled produce imagery overlay
 * - Consistent premium styling
 */

import React from 'react';
import { useAuth } from '../context/authContext';

const PremiumPlanningShell = ({ children, theme = 'tomato' }) => {
    const backgroundImages = {
        tomato: '/images/menuScheduling/tomato_bg.png',
        lemon: '/images/menuScheduling/lemon_bg.png',
        spinach: '/images/menuScheduling/spinach_bg.png'
    };

    const backgroundStyle = {
        backgroundColor: '#EEEEE7', // Beige base
        backgroundImage: `url(${backgroundImages[theme] || backgroundImages.tomato})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        minHeight: '100vh'
    };

    return (
        <div style={backgroundStyle}>
            {children}
        </div>
    );
};

export default PremiumPlanningShell;

